import React, { Component } from 'react';
import config from  '../../../../config';

export default class GalleryItem extends Component {

    renderImage = (document, i) => {
        return (
            <div className={`cbp-item ${this.props.type}`} key={i}>
                <div className="cbp-caption">
                    <div className="cbp-caption-defaultWrap" style={{ minHeight: '278px' }}>
                        <img src={`${config.staticFiles}${document.document_serial}`} alt=""
                             style={{ maxHeight: '278px', width: 'auto', height: 'auto' }}/>
                    </div>
                    <div className="cbp-caption-activeWrap">
                        <div className="cbp-l-caption-alignCenter">
                            <div className="cbp-l-caption-body">
                                <a href={`${config.staticFiles}${document.document_serial}`}
                                   className="cbp-lightbox cbp-l-caption-buttonRight btn default btn-outline uppercase"
                                   data-title={`${this.props.title}<br>${this.props.description}`}>View</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cbp-l-grid-projects-title uppercase text-center uppercase text-center">{this.props.title}</div>
                <div className="cbp-l-grid-projects-desc uppercase text-center uppercase text-center">{this.props.type}</div>
            </div>
        )
    };

    handleUpdateGallery = (e) => {
        this.props.onOpenGalleryUpload(this.props);
    };

    handleDeleteGalleryItem = (e) => {
        this.props.onDeleteGalleryItem(this.props.id);
    };

    render() {
        if (this.props.documents.length > 1) {
            return (
                <div className={`cbp-item ${this.props.type}`}>
                    <div className="cbp-caption">
                        <div className="cbp-caption-defaultWrap" style={{ minHeight: '278px' }}>
                            <img src={`${config.staticFiles}${this.props.documents[0].document_serial}`} alt=""
                                 style={{ maxHeight: '278px', width: 'auto', height: 'auto' }}/>
                        </div>
                        <div className="cbp-caption-activeWrap">
                            <div className="cbp-l-caption-alignCenter">
                                <div className="cbp-l-caption-body">
                                    {this.props.documents.map((item, i) => {
                                        if (i === 0) {
                                            return (
                                                <div key={i}>
                                                    <a data-cbp-lightbox={`gallery-${this.props.id}`}
                                                       href={`${config.staticFiles}${item.document_serial}`}
                                                       className="cbp-lightbox cbp-l-caption-buttonRight btn default btn-outline uppercase"
                                                       data-title={`${this.props.title}<br>${this.props.description}`}>View</a>

                                                    {/*<a onClick={this.handleUpdateGallery} href="#"*/}
                                                       {/*className="cbp-l-caption-buttonRight btn default btn-outline uppercase">Update</a>*/}

                                                    <a onClick={this.handleDeleteGalleryItem} href="#"
                                                       className="cbp-l-caption-buttonRight red btn default btn-outline uppercase">Delete</a>
                                                </div>
                                            )
                                        }

                                        return (
                                            <a data-cbp-lightbox={`gallery-${this.props.id}`}
                                               href={`${config.staticFiles}${item.document_serial}`}
                                               key={i}
                                               className="cbp-lightbox cbp-l-caption-buttonRight"
                                               style={{ display: 'none' }}
                                               data-title={`${this.props.title}<br>${this.props.description}`}>&nbsp;</a>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cbp-l-grid-projects-title uppercase text-center uppercase text-center">{this.props.title}</div>
                    <div className="cbp-l-grid-projects-desc uppercase text-center uppercase text-center">{this.props.type}</div>
                </div>
            )
        }

        return (
            <div className={`cbp-item ${this.props.type}`}>
                <div className="cbp-caption">
                    <div className="cbp-caption-defaultWrap" style={{ minHeight: '278px' }}>
                        <img src={`${config.staticFiles}${this.props.documents[0].document_serial}`} alt=""
                             style={{ maxHeight: '278px', width: 'auto', height: 'auto' }}/>
                    </div>
                    <div className="cbp-caption-activeWrap">
                        <div className="cbp-l-caption-alignCenter">
                            <div className="cbp-l-caption-body">
                                <a data-cbp-lightbox={`gallery-${this.props.id}`} href={`${config.staticFiles}${this.props.documents[0].document_serial}`}
                                   className="cbp-lightbox cbp-l-caption-buttonRight btn default btn-outline uppercase"
                                   data-title={`${this.props.title}<br>${this.props.description}`}>View</a>

                                {/*<a onClick={this.handleUpdateGallery} href="#"*/}
                                   {/*className="cbp-l-caption-buttonRight btn default btn-outline uppercase">Update</a>*/}

                                <a onClick={this.handleDeleteGalleryItem} href="#"
                                   className="cbp-l-caption-buttonRight red btn default btn-outline uppercase">Delete</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cbp-l-grid-projects-title uppercase text-center uppercase text-center">{this.props.title}</div>
                <div className="cbp-l-grid-projects-desc uppercase text-center uppercase text-center">{this.props.type}</div>
            </div>
        )

    }
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Gallery/GalleryItem.js
 **/